import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";

// TODO: Page container of the filters
export const PageContainer = styled.div<{ displayOn?: boolean }>`
  background-color: ${({ theme }) => theme.colors.gray.light};
  display: flex;
  flex-direction: column;
  width: 25%;
  max-width: 345px;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 24px;

  // TODO: mobile search
  @media ${({ theme }) => theme.devices.tablet} {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9999999;
    width: 100%;
    margin: 0;
    display: ${({ displayOn }) => (displayOn ? "block" : "none")};
    min-height: 100vh;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white.normal};
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  flex-direction: column;
  width: 100%;
  margin-top: 2px;
  margin-bottom: 2px;
  flex-direction: column;
  @media ${({ theme }) => theme.devices.laptop} {
    margin-right: 20px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    margin: 0;
    border-radius: 0;
    border: 0.5px solid #d3d3d3;
    margin: 0;
    position: relative;
  }
`;

interface TitleFilterProps {
  searchHidden: boolean;
}
export const Title = styled.span<TitleFilterProps>`
  display: flex;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.green.dark};
  margin-bottom: 8px;
  margin-top: ${({ searchHidden }) => (searchHidden ? "16px" : "0")};
`;

export const Expand = styled.div`
  margin-left: auto;
  font-size: 12px;
  align-self: center;
`;

interface IContent {
  expand: boolean;
}
export const Content = styled.div<IContent>`
  overflow: hidden;

  @media ${({ theme }) => theme.devices.tablet} {
    transition: max-height ${({ theme }) => theme.animation.duration};
    max-height: ${({ expand }) => (expand ? "100vh" : "1px")};
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin: 0;

  @media (max-width: 768px) {
    transition: all 300ms ease-in;
    will-change: max-height, opacity, transition;
  }
`;

export const SearchTitleContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media ${({ theme }) => theme.devices.mobileL} {
  }
`;

export const TotalResults = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.gray.dark};
  white-space: nowrap;
  margin-left: auto;
  margin-top: 20px;
  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 0;
    margin-left: 0;
    text-align: right;
  }
`;

export const MenuCloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const MenuClose = styled(CloseIcon).attrs(props => ({
  fontSize: "40px",
  style: {
    color: props.theme.colors.gray.normal,
    cursor: "pointer",
    fontWeight: 600,
    alignSelf: "center",
  },
}))`
  height: 100%;
  z-index: 999999999;
  color: ${({ theme }) => theme.colors.gray.normal};
  position: relative;
`;

export const FilterCleaner = styled.button`
  cursor: pointer;
  font-size: 12px;
  height: 100%;
  z-index: 999999999;
  color: ${({ theme }) => theme.colors.red.dark};
  background: ${({ theme }) => theme.colors.gray.super_light};
  // border: solid 1px ${({ theme }) => theme.colors.black.normal};
  border: none;
  font-size: 13px;
  font-weight: 600;
  padding: 2px 4px;
  border-radius: 6px;
  position: relative;
  margin-right: 8px;
  font-weight: 600;
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999999; // logo abaixo do Menu que tem z-index: 99999999
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
`;
